import * as React from 'react'

import { Button, Menu, MenuTrigger } from '@fluentui/react-components'
import { ArrowSortRegular } from '@fluentui/react-icons'

import SortMenuPopover from './SortMenuPopover'

const SortMenuButton = (props) => {
  const {
    sortInput,
    setSortInput
  } = props

  const onChange = (e, { name, checkedItems }) => {
    setSortInput((s) => ({ ...s, [name]: checkedItems }))
  }

  return (
    <Menu
      checkedValues={sortInput}
      onCheckedValueChange={onChange}
      persistOnItemClick
      closeOnScroll
    >
      <MenuTrigger>
        <Button
          icon={<ArrowSortRegular />}
        />
      </MenuTrigger>

      <SortMenuPopover
        sortBy={sortInput.sortBy[0]}
      />
    </Menu>
  )
}

export default SortMenuButton
